module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_1.ca3bbd22.png";